module.exports = __webpack_public_path__ + "img/采埃孚.png";